import { Icon } from '@synergy/icons';
import clsx from 'clsx';
import i18next from "i18next";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useGlobalFilterContext } from "../../../contexts/GlobalFilterProvider";
import query from '../../../server/constants.api';
import useFetch from "../../../server/useFetch";
import Theme from "../../../styles/Theme/Theme";
import { Text } from "./Text";

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const StyledWeather = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* margin-bottom: ${Theme.spacing["s05"]}; */
  padding: ${Theme.spacing["s05"]} ${Theme.spacing["s05"]} ${Theme.spacing["s03"]};
  background-color: ${Theme.color["blue-7"]};
  height: 70px;
  box-shadow: ${Theme.shadow.level3};
  border-radius: ${Theme.radius["lg"]};

  color: ${Theme.color["white"]};
  flex-wrap: wrap;
  .time-wrapper {
    display: flex;
    align-self: baseline;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;

    .forecast{
      display: flex;

      div{
        display: flex;
        margin-left: 2px;
      }
    }
  }

  .widget-date{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;
//#endregion

export const Weather = ({ ...props }) => {
  const { isToApplyFilters, subEntity, entity } = useGlobalFilterContext();
  const [currentTime, setCurrentTime] = useState(new Date());
  let currentTimestamp = Math.floor(new Date().getTime() / 1000) - 3600;
  const [tenant, setTenant] = useState(subEntity?.value ? subEntity?.value : entity?.value);

  const {
    data: currentWeather,
    refetch: refetchCurrentWeather
  } = useFetch("/weather/current", "currentWeather", {
    location: 'Cascais',
    timestamp: currentTimestamp
  }, tenant ? true : false, null, query.middlewareURL);

  const {
    data: forecastWeather,
    refetch: refetchForecastWeather
  } = useFetch("/weather/forecast", "forecastWeather", {
    location: 'Cascais',
    timestamp: currentTimestamp
  }, tenant ? true : false, null, query.middlewareURL);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (isToApplyFilters) {
      setTenant(subEntity?.value ? subEntity?.value : entity?.value);
      refetchCurrentWeather();
      refetchForecastWeather();
    }
  }, [isToApplyFilters]);

  const hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const seconds = currentTime.getSeconds();

  //Format hours, minutes, and seconds to have leading zeros if necessary
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  // Options for formatting the date
  const getLanguage = (lang) => {
    switch (lang) {
      case "pt":
        return "pt-PT";

      default:
        return "en-GB";
    }
  };

  // Convert the date to a string format, e.g., "October 9, 2023"
  // Extract day, month, and year
  const day = currentTime.getDate();
  const month = currentTime.toLocaleString(
    getLanguage(i18next.resolvedLanguage),
    { month: "short" }
  );
  const formattedDate = `${day} ${month}`;
  const formattedWeekday = currentTime.toLocaleDateString(
    getLanguage(i18next.resolvedLanguage),
    {
      weekday: "short",
    }
  );

  return (
    <StyledWeather className={clsx(props?.className)}>
      <div className="time-wrapper">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Icon iconsize='sm' icon="Clock" color="teal-3" />
          <Text
            $fontSize="text_md"
            $marginRight="s04"
            $weight="light"
          >
            {formattedHours}:{formattedMinutes}
          </Text>

          {currentWeather?.length > 0 ? (
            <>
              <Icon iconsize='sm' icon={currentWeather[currentWeather.length - 1].Weather} color="teal-3" />
              <Text $fontSize="text_md" $weight="light">
                {Number(currentWeather[currentWeather.length - 1].Temperature).toFixed(0)}ºC
              </Text>
            </>
          ) : null}
        </div>
        {forecastWeather?.length > 0 ?
          <div className="forecast">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Text $fontSize="text_sm" $marginLeft="s02" $weight="light">+1h</Text>
              <Text $fontSize="text_sm" $marginLeft="s02" $weight="light">
                {Number(forecastWeather[forecastWeather.length - 1].Temperature).toFixed(0)}ºC
              </Text>
              <Icon iconsize='xs' icon={forecastWeather[forecastWeather.length - 1].Weather} color="teal-3" />
            </div>

            {forecastWeather[1] ?
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Text $fontSize="text_sm" $marginLeft="s02" $weight="light">+2h</Text>
                <Text $fontSize="text_sm" $marginLeft="s02" $weight="light">
                  {Number(forecastWeather[forecastWeather.length - 2].Temperature).toFixed(0)}ºC
                </Text>
                <Icon iconsize='xs' icon={forecastWeather[forecastWeather.length - 2].Weather} color="teal-3" />
              </div>
              : null}
          </div>
          : null}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Text $fontSize="text_sm" >{tenant}</Text>
        <div className="widget-date">
          <Text $fontSize="text_sm" $fontColor="white" $weight="semibold">
            {formattedWeekday}
          </Text>
          &nbsp;
          <Text $fontSize="text_sm" $fontColor="white" $weight="light">
            {formattedDate}
          </Text>
        </div>
      </div>
    </StyledWeather>
  );
};
